import { createTheme } from '@mui/material/styles';
import { tokens } from './tokens';

export const theme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: tokens.colors.bg,
      paper: tokens.colors.panel,
    },
    text: {
      primary: tokens.colors.txt,
      secondary: tokens.colors.muted,
    },
    primary: {
      main: tokens.colors.indigo,
      contrastText: '#08131a',
    },
    secondary: {
      main: tokens.colors.cyan,
      contrastText: '#ffffff',
    },
    success: { main: tokens.colors.ok },
    warning: { main: tokens.colors.gold },
    error: { main: tokens.colors.red },
    divider: tokens.colors.line,
  },

  shape: {
    borderRadius: tokens.radius.md,
  },

  typography: {
    fontFamily: tokens.font.family,
    fontSize: tokens.font.baseSize,
    h4: { fontWeight: 730, letterSpacing: '-0.4px' },
    h5: { fontWeight: 680 },
    h6: { fontWeight: 650 },
    body1: { fontSize: 14.5 },
    body2: { fontSize: 13.5, color: tokens.colors.muted },
    button: { textTransform: 'none', fontWeight: 650 },
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          border: `1px solid ${tokens.colors.line}`,
          backgroundImage: 'none', // evita el overlay de elevation de MUI
        },
        elevation1: {
          boxShadow: tokens.shadow.card,
        },
      },
      defaultProps: {
        elevation: 1,
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radius.lg,
          border: `1px solid ${tokens.colors.line}`,
          boxShadow: tokens.shadow.card,
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radius.md,
          fontWeight: 650,
          padding: '10px 15px',
        },
        sizeLarge: {
          padding: '11px 18px',
        },
        sizeSmall: {
          padding: '8px 12px',
          fontSize: 12.5,
        },
        containedPrimary: {
          backgroundImage: tokens.gradient.main,
          color: '#08131a',
          boxShadow: tokens.shadow.gradientButton,
          '&:hover': {
            backgroundImage: tokens.gradient.main,
            filter: 'brightness(1.05)',
            boxShadow: tokens.shadow.gradientButton,
          },
        },
        outlined: {
          borderColor: tokens.colors.line2,
          '&:hover': {
            borderColor: 'rgba(20,24,45,.28)',
            backgroundColor: '#f5f6f8',
          },
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 650,
          borderRadius: 20,
        },
        colorDefault: {
          backgroundColor: tokens.colors.panel2,
          color: tokens.colors.muted,
        },
      },
    },

    MuiPaginationItem: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          '&.Mui-selected': {
            backgroundColor: tokens.colors.indigo,
            color: '#fff',
            '&:hover': {
              backgroundColor: '#2c3441',
            },
          },
        },
      },
    },

    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radius.md,
          border: '1px solid transparent',
        },
        standardWarning: {
          backgroundColor: 'rgba(176,125,26,.12)',
          color: tokens.colors.gold,
        },
        standardInfo: {
          backgroundColor: tokens.colors.panel2,
          color: tokens.colors.muted,
        },
        standardSuccess: {
          backgroundColor: 'rgba(31,157,99,.13)',
          color: tokens.colors.ok,
        },
        standardError: {
          backgroundColor: 'rgba(229,72,77,.13)',
          color: tokens.colors.red,
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: tokens.colors.line,
        },
      },
    },
  },
});

export default theme;